import Addinstution from "../../../components/admin/institution/AddInstution";
import Admin from "../../Admin";

const InstitutionAdd = () => {
    return ( 
        <Admin>
            
            <Addinstution/>
        </Admin>
     );
}
 
export default InstitutionAdd;